module.exports = __webpack_public_path__ + "static/media/faqBalance-en-de.a0e09b6b.vtt";